// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CrewResource_abstract } from './../abstract/SagaSchema/CrewResource_abstract';
export class CrewResource extends CrewResource_abstract {}
